import React
 ,{ useState, useEffect } 
 from "react";
import renderSelectField from "../../../../shared/components/form/Select";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { Alert, Spinner } from "reactstrap";
import { MdRefresh } from "react-icons/md";
import { getFEPs } from "../../actions/institution.actions";

const FepDropDown = props => {
  const { fep, dispatch, disabled, required } = props;
  const [ fepData, setFepData] = useState(null)

  const getFeps = (val) => {
   dispatch(getFEPs(val));
  };
  useEffect(() => {
      getFeps()
  }, [])
  
  const handleInputChange = val => {
    if(val !== "") {
        const newData = fep.fep_response !== undefined && fep.fep_response !== null ? fep.fep_response?.filter(_fep => (_fep.code).includes(val)) : null;
        (newData && newData.length) && setFepData(newData);
    } else {
        setFepData(fep.fep_response)
    }
  }
 
  return (
    <div className="form__form-group">
      <span className={`form__form-group-label bold-text ${required ? "required" : ""}`}>
        FEP
      </span>
      <div className="form__form-group-field">
        <Field
          id="fepCode"
          name="fepCode"
          disabled={disabled}
          customChange={()=>{}}
          component={renderSelectField}
          placeholder="Enter a value to search fep"
          onInputChange={handleInputChange}
          options={fepData || []}
          valueKey="code"
          labelKey="name"
        />
      </div>
      {fep.fep_error ? (
        <Alert color="danger">
          Could not fetch FEPs
          {fep.fep_loading ? (
            <Spinner className="float-right" size="sm" color="danger" />
          ) : (
            <MdRefresh
              onClick={getFeps}
              className="float-right pointer reducedIconWidth"
              size={20}
            />
          )}
        </Alert>
      ) : null}
    </div>
  );
};

export default connect(state => ({
  fep: state.getInstitution
}))(FepDropDown);
